// import '../styles/style.scss';

const DEFAULT = {};

export class FormPopup
{
	container = null;
	maskFields = [];

	constructor(options = {})
	{
		this.options = BX.merge(DEFAULT, options);

		BX.ready(this.init.bind(this));
	}

	init()
	{
		const { IMask } = window;
		this.container = document.getElementById(this.options.id);

		this.maskFields = [...this.container.querySelectorAll('[data-inputmask]')];

		if (this.maskFields)
		{
			this.maskFields.forEach(item => {
				
				if (!item.dataset.inputmask)
					return;

				const maskOptions = JSON.parse(item.dataset.inputmask);

				IMask(item, maskOptions);
			});
		}
	}
}
